export default function ContactSection() {
  return (
    <section id="contact" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="bg-gradient-to-r from-primary-500/5 via-accent-500/10 to-primary-500/5 rounded-2xl p-8 md:p-12 border border-background-200/70">
          <div className="flex flex-col lg:flex-row items-center gap-8">
            <div className="flex-1 text-center lg:text-left">
              <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900">联系我们</h2>
              <p className="text-sm text-foreground-500 mt-3 leading-relaxed max-w-lg mx-auto lg:mx-0">
                欢迎影迷朋友投稿影评、推荐片单或反馈问题。我们的编辑团队会在3个工作日内回复，共同打造更好的电影分享平台。
              </p>
              <div className="flex flex-wrap items-center justify-center lg:justify-start gap-4 mt-5">
                <div className="flex items-center gap-2 text-sm text-foreground-600">
                  <i className="ri-mail-line text-primary-500 text-lg"></i>
                  <span>contact@8090movie.com</span>
                </div>
                <div className="flex items-center gap-2 text-sm text-foreground-600">
                  <i className="ri-wechat-line text-accent-500 text-lg"></i>
                  <span>8090影视官方</span>
                </div>
              </div>
            </div>
            <div className="shrink-0">
              <a
                href="mailto:contact@8090movie.com"
                className="inline-flex items-center gap-2 px-8 py-3.5 rounded-full bg-primary-500 text-white font-medium text-sm hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
              >
                <i className="ri-send-plane-line"></i>
                立即投稿
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}